import mapboxgl from 'mapbox-gl'

export default class Isochrone {
  constructor (id, lng, lat, rel, mode = 'driving', duration = 10) {
    this.lat = lat
    this.lng = lng
    this.mode = mode
    this.duration = duration
    this.id = id || Date.now().toString()
    this.relativeNum = rel
    this.lineColor = this.possibleColors[this.colorKey]
  }

  updateData (evnt) {
    const details = evnt.detail
    this.mode = details.mode
    this.duration = details.duration
  }

  update (lng, lat, duration, mode) {
    this.lng = lng
    this.lat = lat
    this.duration = duration
    this.mode = mode
  }

  async getSource () {
    const json = await this.getData()

    return {
      type: 'geojson',
      data: json
    }
  }

  layer () {
    return this.layerDefaults
  }

  async getData (url) {
    const query = await fetch(this.url, { method: 'GET' })
    const json = await query.json()
    return json
  }

  get url () {
    return `${this.urlBase}${this.mode}/${this.lng},${this.lat}?contours_minutes=${this.duration}&polygons=true&access_token=${mapboxgl.accessToken}`
  }

  get urlBase () {
    return 'https://api.mapbox.com/isochrone/v1/mapbox/'
  }

  get layerDefaults () {
    return {
      'id': this.id,
      'type': 'line',
      'source': this.id,
      'layout': { 'line-join': 'round' },
      'paint': {
        'line-color': this.lineColor,
        'line-opacity': 0.75,
        'line-width': 3
      }
    }
  }

  get innerHTML () {
    return `
      <div class="text-sm font-medium">
        Travel mode
      </div>

      <div class="flex gap-2 bg-gray-100 rounded-full my-4 ">
        <label for="mode_walking" class="flex items-center gap-1 px-4 py-1 rounded-full text-slate-700 has-checked:bg-sky-200 has-checked:text-sky-950 has-checked:font-medium hover:cursor-pointer"
          data-action="click->maps--isochrone#update">
          <input type="radio" name="mode" value="walking" class="hidden" ${this.mode === 'walking'  ? 'checked' : ''} data-maps--isochrone-target="mode" id="mode_walking">
          <i class="fa_icon fal fa-walking"></i>
          <span> Walking</span>
        </label>

        <label for="mode_driving" class="flex items-center gap-1 px-4 py-1 rounded-full text-slate-700 has-checked:bg-sky-200 has-checked:text-sky-950 has-checked:font-medium hover:cursor-pointer"
          data-action="click->maps--isochrone#update">
          <input type="radio" name="mode" value="driving" class="hidden" ${this.mode === 'driving' ? 'checked' : ''} data-maps--isochrone-target="mode" id="mode_driving">
          <i class="fa_icon fal fa-car-side"></i>
          <span> Driving</span>
        </label>

        <label for="mode_cycling" class="flex items-center gap-1 px-4 py-1 rounded-full text-slate-700 has-checked:bg-sky-200 has-checked:text-sky-950 has-checked:font-medium hover:cursor-pointer"
          data-action="click->maps--isochrone#update">
          <input type="radio" name="mode" value="cycling" class="hidden" ${this.mode === 'cycling' ? 'checked' : ''} data-maps--isochrone-target="mode" id="mode_cycling"></input>
          <i class="fa fa-bicycle fa_icon"></i>
          <span> Cycling</span>
        </label>
      </div>

      <div class="text-sm font-medium">
        Travel time
      </div>

      <div class="flex justify-between my-4 bg-gray-100 rounded-full">
        <label for="duration_10" class="flex items-center gap-1 px-4 py-1 rounded-full text-slate-700 has-checked:bg-sky-200 has-checked:text-sky-950 has-checked:font-medium hover:cursor-pointer"
          data-action="click->maps--isochrone#update">
          <input type="radio" name="duration" value="10" class="hidden" ${this.duration === 10 ? 'checked' : ''} data-maps--isochrone-target="duration" id="duration_10">
          <span>10 minutes</span>
        </label>
        <label for="duration_20" class="flex items-center gap-1 px-4 py-1 rounded-full text-slate-700 has-checked:bg-sky-200 has-checked:text-sky-950 has-checked:font-medium hover:cursor-pointer"
          data-action="click->maps--isochrone#update">
          <input type="radio" name="duration" value="20" class="hidden" ${this.duration === 20 ? 'checked' : ''} data-maps--isochrone-target="duration" id="duration_20">
          <span>20 minutes</span>
        </label>
        <label for="duration_30" class="flex items-center gap-1 px-4 py-1 rounded-full text-slate-700 has-checked:bg-sky-200 has-checked:text-sky-950 has-checked:font-medium hover:cursor-pointer"
          data-action="click->maps--isochrone#update">
          <input type="radio" name="duration" value="30" class="hidden" ${this.duration === 30 ? 'checked' : ''} data-maps--isochrone-target="duration" id="duration_30">
          <span>30 minutes</span>
        </label>
      </div>

      <div class="flex border-t border-gray-200 pt-4">
        <a class="btn btn-sm btn-ringed" data-action="click->maps--isochrone#remove">
          <i class="fa fa-eye-slash fa_icon pr-2"></i> Hide
        </a>
      </div>
    `
  }

  get colorKey () {
    return this.relativeNum % this.possibleColors.length
  }

  get possibleColors () {
    return [
      "#ef4444", // red 500
      "#f97316", // orange 500
      "#fbbf24", // amber 400
      "#d946ef", // fuchsia 500
      "#ec4899", // pink 500
      "#f43f5e", // rose 500
      "#b91c1c", // red 700
      "#c2410c", // orange 700
      "#b45309", // amber 700
      "#a21caf", // fuchsia 700
      "#be185d", // pink 700
    ]
  }

  get modeIndex () {
    return {
      'walking': 0,
      'driving': 1,
      'cycling': 2
    }[this.mode]
  }

  get durationIndex () {
    return {
      10: 0,
      20: 1,
      30: 2
    }[this.duration]
  }
}
